import * as Theme from "../../../components/styles"
import React from "react"
import tick from "../../../images/invert_tick.png"

export const Tick = ({ selected }) => {
  if (selected !== true) return null

  return <Theme.TickIcon src={tick} aria-label="Selected" />
}
